module.exports = __webpack_public_path__ + "media/images/views/tech_client/benefit-3-8763268beb93b7c3cc5908bdfc0399f3.png";